@if (!text) {
    <div class="well well-status-warten" translate>
        <ng-content></ng-content>
    </div>
} @else {
    <div class="well well-status-warten" [innerHTML]="text | translate"></div>
}
